import PermissionCheckbox from '././PermissionCheckBox';

export default function MenuPermissionRow({
  menu,
  permissions,
  onChange,
  level = 0
}) {

  return (
    <>
      <tr>
        <td className={`menu-level-${level}`}>
          {menu.title}
        </td>
        <td>
          <PermissionCheckbox
            value={permissions[menu.id] || {}}
            onChange={val => onChange(menu, val)}
          />
        </td>
      </tr>

      {menu.children?.map(child => (
        <MenuPermissionRow
          key={child.id}
          menu={child}
          permissions={permissions}
          onChange={onChange}
          level={level + 1}
        />
      ))}
    </>
  );
}
